"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.provider = void 0;
var _pusherJs = _interopRequireDefault(require("pusher-js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var stringifyWithNull = function stringifyWithNull(obj) {
  return JSON.stringify(obj, function (k, v) {
    return v === undefined ? null : v;
  });
};

/**
 * On whiteboard close, owner sends current state to remote peers.
 * Remote peers tear down too quickly(unsubscribing listeners) and are unable to store the last state.
 *
 * Hack: To overcome this, attach 2 listeners:
 * one for storing the message(won't be unsubscribed),
 * one for calling the actual whiteboard callback(will be unsubscribed on whiteboard close)
 *
 * This way the last state is always received and stored
 */

/**
 * Base class which can be extended to use various realtime communication services.
 * Methods to broadcast and subscribe to events.
 *
 * Stores the last message received/broadcasted to resend when required(when board is ready)
 */
var PusherCommunicationProvider = /*#__PURE__*/_createClass(function PusherCommunicationProvider() {
  var _this = this;
  _classCallCheck(this, PusherCommunicationProvider);
  _defineProperty(this, "init", function () {
    var roomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    if (_this.initialized) {
      return;
    }

    /** @private */
    _this.pusher = new _pusherJs["default"](process.env.REACT_APP_PUSHER_APP_KEY, {
      cluster: "ap2",
      authEndpoint: process.env.REACT_APP_PUSHER_AUTHENDPOINT
    });

    // Pusher.default.logToConsole = true;

    /** @private */
    _this.channel = _this.pusher.subscribe("private-".concat(roomId));

    /**
     * When events(peer-join) are sent too early before subscribing to a channel,
     * resend last event after subscription has succeeded.
     */
    _this.channel.bind("pusher:subscription_succeeded", _this.resendLastEvents);
    console.log("Whiteboard initialized communication through Pusher");
    _this.initialized = true;
  });
  _defineProperty(this, "storeEvent", function (eventName, message) {
    _this.lastMessage[eventName] = _objectSpread({
      eventName: eventName
    }, message);
  });
  _defineProperty(this, "getStoredEvent", function (eventName) {
    return _this.lastMessage[eventName];
  });
  _defineProperty(this, "broadcastEvent", function (eventName) {
    var _this$channel;
    var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _this.storeEvent(eventName, arg);
    (_this$channel = _this.channel) === null || _this$channel === void 0 ? void 0 : _this$channel.trigger("client-".concat(eventName), stringifyWithNull(_objectSpread({
      eventName: eventName
    }, arg)));
  });
  _defineProperty(this, "subscribe", function (eventName, cb) {
    var _this$channel2, _this$channel3;
    (_this$channel2 = _this.channel) === null || _this$channel2 === void 0 ? void 0 : _this$channel2.bind("client-".concat(eventName), function (message) {
      return _this.storeEvent(eventName, message);
    });
    (_this$channel3 = _this.channel) === null || _this$channel3 === void 0 ? void 0 : _this$channel3.bind("client-".concat(eventName), cb);
    return function () {
      var _this$channel4;
      (_this$channel4 = _this.channel) === null || _this$channel4 === void 0 ? void 0 : _this$channel4.unbind("client-".concat(eventName), cb);
    };
  });
  _defineProperty(this, "resendLastEvents", function () {
    for (var eventName in _this.lastMessage) {
      if (_this.lastMessage[eventName]) {
        var _this$channel5;
        (_this$channel5 = _this.channel) === null || _this$channel5 === void 0 ? void 0 : _this$channel5.trigger("client-".concat(eventName), _this.lastMessage[eventName]);
      }
    }
  });
  /** @private */
  this.initialized = false;
  /** @private */
  this.lastMessage = {};
}); /**
     * @type {PusherCommunicationProvider}
     */
var provider = new PusherCommunicationProvider();
exports.provider = provider;